import {FunctionComponent} from 'react';

const Alinea: FunctionComponent = () => (
    <span className="alinea"/>
);

export default Alinea;